'use strict';

angular.module('clientDashboardApp').service('pagingService', function ($q, $http, $log, $filter, searchService) {


  var currentPageNum = null;

  var setCurrentPage = function(pageNum){
    currentPageNum = pageNum;
  }

  var getCurrentPage = function(){
    return currentPageNum;
  }

  var resetPagingState = function(){
    currentPageNum = null;
  }

  var loadSearchResults = function (searchParams, searchResult) {
    searchResult.loading = true;

    var deferred = $q.defer();
    var params = angular.copy(searchParams);
    $http
      .get(searchResult.url, {
        params: params
      })
      .success(function (data, status, headers, config) {
        params.cursor = data.cursor;
        searchResult.results = searchResult.results.concat(data.results);
        searchResult.totalResults = data.totalResults;
        if (data.extraData) {
          searchResult.extraData = data.extraData;
        }
        searchResult.params = params;
        searchResult.callback(searchResult);
        searchResult.loading = false;
      })
      .error(function (data, status, headers, config) {
        $log.error('Error occurred while getting search results!');
      });

    return deferred.promise;
  };

  function SearchResult(reportUrl, callback) {
    this.results = [];
    this.params = {};
    this.loading = false;
    this.url = reportUrl;
    this.callback = callback;
  }

  SearchResult.prototype.allReceivedResults = function () {
    return this.results;
  };

  SearchResult.prototype.sortResults = function (sortField, sortOrder) {
    delete this.params.cursor;
    this.params.sortField = sortField;
    this.params.sortOrder = sortOrder;

    //Clear existing results
    this.results = [];

    return loadSearchResults(this.params, this);
  };

  SearchResult.prototype.loadMoreResults = function (limit) {
    if (this.loading || !this.hasMoreResults()) {
      //We are already awaiting results
      return;
    }
    this.params.limit = limit;
    return loadSearchResults(this.params, this);
  };

  SearchResult.prototype.hasMoreResults = function () {
    return this.params.cursor > 0;
  };

  SearchResult.prototype.hasAnyResults = function () {
    return this.results.length > 0;
  };

  SearchResult.prototype.export = function () {
    var exportParams = {};
    angular.copy(this.params,exportParams);
    delete exportParams.limit;
    delete exportParams.cursor;
    exportParams.type = "listings";
    return searchService.exportResults(exportParams);
  };

  function PagedData(data, pageSize, sortField, reverseOrder) {
    this.currentPageNum = 1;
    this.pagedItems = [];
    this.pageSize = pageSize;
    this.allResults_ = data;
    this.totalResults = data.length;

    if(angular.isDefined(sortField)) {
      this.sortResults(sortField, reverseOrder);
    }else {
      this.updatingPaging();
    }
  }

  PagedData.prototype.updatingPaging = function()
  {
    for (var i = 0; i < this.totalResults; i++) {
      if (i % this.pageSize === 0) {
        this.pagedItems[Math.floor(i / this.pageSize)] = [this.allResults_[i]];
      } else {
        this.pagedItems[Math.floor(i / this.pageSize)].push(this.allResults_[i]);
      }
    }
  };

  PagedData.prototype.sortResults = function (sortField, reverseOrder) {
    this.allResults_ = $filter('orderBy')(this.allResults_, sortField, reverseOrder);
    this.updatingPaging();
  };

  PagedData.prototype.allResults = function () {
    return this.allResults_;
  };

  PagedData.prototype.currentResults = function () {
    return this.pagedItems[this.currentPageNum - 1];
  };

  PagedData.prototype.hasAnyResults = function () {
    return this.pagedItems.length > 0;
  };

  return {
    createSearch: function createSearch(reportUrl, params, callback) {
      return loadSearchResults(params, new SearchResult(reportUrl, callback));
    },
    createPagingData: function createPagingData(data, pageSize, sortField, reverseOrder) {
      return new PagedData(data, pageSize, sortField, reverseOrder);
    },
    setCurrentPage: setCurrentPage,
    getCurrentPage: getCurrentPage,
    resetPagingState: resetPagingState
  }
});
